export const apiRoutes = {
  getCampaigns: () => '/campaigns',
  duplicateCampaign: (campaignId: string) => `/campaigns/${campaignId}/duplicate`,
};
